export default __webpack_public_path__ + "static/media/time_icon.19b6e1e6.svg";